"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tdwReport = tdwReport;
var _tencentDocReport = require("@tencent/tencent-doc-report");
function tdwReport(param, immediate) {
  var defaultOpt = {
    table: 'dc03111'
  };
  var distOpt = Object.assign({}, defaultOpt, param);
  (0, _tencentDocReport.tdw)(distOpt, {
    showLog: true,
    immediate: immediate
  });
}